import { useEffect, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { Group, NumberInput } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import dayjs from "dayjs";

const FilterLeadsStatus = ({ setValue, value }) => {
  const lang = useLanguage((s) => s.language);

  const [number, setNumber] = useState(
    value ? parseInt(value.split("_")[2]) : 0
  );
  const [dateRange, setDateRange] = useState({
    start_date: value ? dayjs(value.split("_")[0]) : dayjs().subtract(1, "day"),
    end_date: value ? dayjs(value.split("_")[1]) : dayjs(),
  });

  useEffect(() => {
    if (dateRange.start_date && dateRange.end_date) {
      let result = `${
        new Date(dateRange.start_date).toISOString().split("T")[0]
      }_${new Date(dateRange.end_date).toISOString().split("T")[0]}_${number}`;
      setValue(result);
    }
  }, [setValue, dateRange, number]);

  return (
    <Group>
      <NumberInput
        value={number}
        onChange={setNumber}
        required
        w={75}
        allowNegative={false}
        allowDecimal={false}
      />

      <DatePickerInput
        type="range"
        placeholder={lang.reports.period}
        value={[dateRange.start_date, dateRange.end_date]}
        onChange={(v) =>
          setDateRange({
            start_date: v[0],
            end_date: v[1],
          })
        }
        maxDate={new Date()}
        radius={"md"}
        valueFormat="DD / MM / YYYY"
        w={210}
        name="period"
        popoverProps={{ zIndex: 1500 }}
        inputMode="text"
      />
    </Group>
  );
};

export default FilterLeadsStatus;
